/* CARAMELO — Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Scroll reveal ── */
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll(
    '.product-card, .benefit-card, .step, .testimonial-card, .banner-card'
  ).forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity .5s ease, transform .5s ease';
    io.observe(el);
  });

  /* ── Fetch cart count on load ── */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var el = document.querySelector('.cart-count');
      if (el) el.textContent = cart.item_count;
    })
    .catch(function () {});

  /* ── Product page: thumbnail gallery ── */
  var thumbs = document.querySelectorAll('.product-gallery img[src*="120x120"]');
  var mainImg = document.querySelector('.product-gallery > img');
  if (mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.src.replace('120x120', '800x800');
        thumbs.forEach(function (t) { t.style.borderColor = 'var(--border-light)'; });
        thumb.style.borderColor = 'var(--yellow)';
      });
    });
  }

});
